import { Token } from '@/models/core/models'

export function revokeToken(token: Token) {
  apiClient.revokeToken(token.id).then((response) => {
    createSnackbar({
      message: 'Successfully revoked!',
      type: 'is-success',
    })
  })
}
